import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEts = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_4780_12580)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_4780_12580",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 24,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M0 0L0 24H24V0H0Z",
				fill: "currentColor"
			})
		}), /* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_4780_12580)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M3.42583 5.13177C3.42583 4.62661 3.60083 4.19902 3.95083 3.84902C4.30083 3.49902 4.72841 3.32402 5.23358 3.32402L18.6181 3.32403C19.1232 3.32403 19.5508 3.49903 19.9008 3.84903C20.2508 4.19903 20.4258 4.62661 20.4258 5.13178V7.49998C20.4258 7.71249 20.3539 7.89059 20.2101 8.03419C20.0662 8.17809 19.8881 8.24999 19.6756 8.24999C19.4629 8.24999 19.2848 8.17809 19.1413 8.03419C18.9977 7.89059 18.9258 7.71249 18.9258 7.49998V5.13178C18.9258 5.05478 18.8937 4.98428 18.8296 4.92028C18.7656 4.85611 18.6951 4.82403 18.6181 4.82403L5.23358 4.82402C5.15658 4.82402 5.08608 4.85611 5.02208 4.92028C4.95791 4.98428 4.92583 5.05477 4.92583 5.13177V18.5163C4.92583 18.5933 4.95791 18.6638 5.02208 18.7278C5.08608 18.792 5.15658 18.824 5.23358 18.824H7.74998C7.9625 18.824 8.1406 18.896 8.2842 19.0398C8.4281 19.1836 8.5 19.3618 8.5 19.5743C8.5 19.787 8.4281 19.965 8.2842 20.1085C8.1406 20.2522 7.9625 20.324 7.74998 20.324H5.23358C4.72841 20.324 4.30083 20.149 3.95083 19.799C3.60083 19.449 3.42583 19.0215 3.42583 18.5163V5.13177Z",
				fill: "#60646C"
			}), /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M20.8601 11.5C21.2743 11.5 21.6101 11.8358 21.6101 12.25C21.6101 12.6642 21.2743 13 20.8601 13H20.4348V18.524C20.4348 19.0292 20.2598 19.4567 19.9098 19.8067C19.5598 20.1567 19.1322 20.3317 18.6271 20.3317V18.8317C18.7041 18.8317 18.7746 18.7997 18.8386 18.7355C18.9027 18.6715 18.9348 18.601 18.9348 18.524V13H18.4128C17.9986 13 17.6628 12.6642 17.6628 12.25C17.6628 11.8358 17.9986 11.5 18.4128 11.5H20.8601ZM12.5 20.83C12.5 21.2442 12.1642 21.58 11.75 21.58C11.3358 21.58 11 21.2442 11 20.83V18.3827C11 17.9685 11.3358 17.6327 11.75 17.6327C12.1642 17.6327 12.5 17.9685 12.5 18.3827V18.8329H18.627V20.3329H12.5V20.83Z",
				fill: "#60646C"
			})]
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_4780_12580",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgEts;
